export enum MeritTerminationState {
  None = 'None',
  ForReview = 'ForReview',
  Rejected = 'Rejected',
  Finalized = 'Finalized'
}
